import React from 'react';
import ImageDivider from './imageOnly';
import ImageWithText from './imageWithText';

/**
 * Component that counts down to a date specified in the config/**
 * Hero Component
 * @param {object} params Incoming Params
 * @returns {XML} A new copyright component
 */
const Divider = ({
  image, text, showSocial, videoId,
}) => {
  if (text) {
    return <ImageWithText image={image} text={text} showSocial={showSocial} videoId={videoId} />;
  }
  return <ImageDivider image={image} />;
};

export default Divider;



// WEBPACK FOOTER //
// ./src/components/dividers/components/divider.js